import moment from "moment";

export const fmtDate = (v) => (v ? moment(v).format("DD/MM/YYYY") : "-");
export const fmtDateTime = (v) => (v ? moment(v).format("HH:mm DD/MM/YYYY") : "-");
export const fmtTime = (v) => (v ? moment(v).format("HH:mm") : "-");

// mm-yyyy cho các API theo tháng
export const monthKey = (d = new Date()) => moment(d).format("MM-YYYY");
// yyyy-MM-dd cho các API theo ngày
export const dayKey = (d = new Date()) => moment(d).format("YYYY-MM-DD");

export const fmtNumber = (n) =>
  n === null || n === undefined || n === "" ? "-" : Number(n).toLocaleString("vi-VN");

// Ghép base URL cho ảnh trả về từ BE (filePath tương đối)
export const resolveImageUrl = (path, baseUrl) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path) || path.startsWith("data:") || path.startsWith("blob:")) {
    return path;
  }
  const base = (baseUrl || "").replace(/\/+$/, "");
  const rel = String(path).replace(/^\/+/, "");
  return `${base}/${rel}`;
};
